import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { GameInfo } from "../types";
import dayjs from "dayjs";
import { CONDENSED_FONT_FAMILY } from "../../../constants";
import { useLeagueLogo } from "../../../../data/LeagueEnvironmentProvider";

export default function GameCard({
  gameInfo,
  teamAbbrev,
  teamId,
}: {
  gameInfo: GameInfo;
  teamAbbrev: string;
  teamId: number;
}) {
  const getTeamLogoUrl = useLeagueLogo();

  return (
    <Stack
      spacing={0.5}
      sx={{
        ".MuiTypography-root": {
          fontFamily: CONDENSED_FONT_FAMILY,
        },
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="center"
        textTransform={"uppercase"}
      >
        {dayjs(gameInfo.date).format("MMM D, YYYY")}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center">
          <img
            src={getTeamLogoUrl(
              gameInfo.isHome ? gameInfo.opponentId : teamId
            )}
            alt={gameInfo.isHome ? gameInfo.opponent : teamAbbrev}
            style={{ width: 40, height: 40 }}
          />
          <Stack alignItems="center">
            <Typography variant="h6" fontWeight={700}>
              {gameInfo.isHome ? gameInfo.opponent : teamAbbrev}
            </Typography>
            <Typography variant="h6" fontWeight={700} lineHeight={1}>
              {gameInfo.isHome ? gameInfo.opponentScore : gameInfo.teamScore}
            </Typography>
          </Stack>
        </Stack>
        <Typography variant="body2" fontWeight={400}>
          vs
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Stack alignItems="center">
            <Typography variant="h6" fontWeight={700}>
              {gameInfo.isHome ? teamAbbrev : gameInfo.opponent}
            </Typography>
            <Typography variant="h6" fontWeight={700} lineHeight={1}>
              {gameInfo.isHome ? gameInfo.teamScore : gameInfo.opponentScore}
            </Typography>
          </Stack>
          <img
            src={getTeamLogoUrl(
              gameInfo.isHome ? teamId : gameInfo.opponentId
            )}
            alt={gameInfo.isHome ? teamAbbrev : gameInfo.opponent}
            style={{ width: 40, height: 40 }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
